var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_781_586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 14.875H8.75V16.125H13.75V14.875Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.875H6.25V16.125H7.5V14.875Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11.75H8.75V13H13.75V11.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.75H6.25V13H7.5V11.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 8.625H8.75V9.875H13.75V8.625Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.625H6.25V9.875H7.5V8.625Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.625 3.625H13.75V3C13.75 2.66848 13.6183 2.35054 13.3839 2.11612C13.1495 1.8817 12.8315 1.75 12.5 1.75H7.5C7.16848 1.75 6.85054 1.8817 6.61612 2.11612C6.3817 2.35054 6.25 2.66848 6.25 3V3.625H4.375C4.04348 3.625 3.72554 3.7567 3.49112 3.99112C3.2567 4.22554 3.125 4.54348 3.125 4.875V18C3.125 18.3315 3.2567 18.6495 3.49112 18.8839C3.72554 19.1183 4.04348 19.25 4.375 19.25H15.625C15.9565 19.25 16.2745 19.1183 16.5089 18.8839C16.7433 18.6495 16.875 18.3315 16.875 18V4.875C16.875 4.54348 16.7433 4.22554 16.5089 3.99112C16.2745 3.7567 15.9565 3.625 15.625 3.625ZM7.5 3H12.5V5.5H7.5V3ZM15.625 18H4.375V4.875H6.25V6.75H13.75V4.875H15.625V18Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.a980bb8d83f1bed0de7761665f506ea8.svg";
export { ForwardRef as ReactComponent };